module.exports = {
	"articleTitle1": "Athletic Department reveals plan for South Campus revamp",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Cliff Keen Arena",
	"articleLink2": "https://www.michigandaily.com/section/wrestling/huntley-cleans-second-senior-night",
	"articleSnippet1": "Sep 13, 2012 ... The proposal calls for transplanting the Michigan volleyball team from Cliff Keen \nArena, where it is currently housed, to a new multi-purpose ...",
	"articleSnippet2": "Feb 14, 2016 ... Huntley wrestled his last regular-season match Friday night at Cliff Keen Arena, \nwinning against Purdue's Drake Stein with an impressive 16-1 ...",
	"totalMisc": 0,
	"articleTitle2": "Huntley cleans up at second Senior Night ",
	"address": "616 E. Hoover St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/151022/del.VOL_.vsPurdue.9.25.15.487.jpg?itok=e54Ht5FN",
			"author": "Delaney Ryan",
			"caption": "Caroline Knop returned from injury against Penn State on Wednesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170129/msk.WRS_.vsLehigh.1.29.17.0323.jpg?itok=_vQQ9kty",
			"author": "Max Kuang",
			"caption": "Senior Brian Murphy's pin capped a run of four consecutive match wins for the Wolverines on Sunday."
		}
	],
	"position": {
		"lat": 42.269429,
		"lng": -83.74173
	},
	"tips": [],
	"articleLink1": "#",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cliffkeen.json
// module id = 852
// module chunks = 0